<template>
    <nav>
        <AlertMessages
            v-if="alertValue"
            :alert-type="alertType" 
            :alert-msg="alertMsg"
            @reset="alertValue = false"
        />
        <v-row
            v-if="!loadingData && storeCustomer.attributes"
            align="center"
            class="mx-auto"
        >
            <v-col
                cols="11"
                class="mx-auto px-0"
            >
                <v-row>
                    <v-col cols="12" lg="6">
                        <p>{{ $t('customerProfileOverview') }}</p>
                        <v-card rounded="xxl" class="elevation-2 pa-5" data-testid="customer-overview-card">
                            <!-- <p class="text-h6" data-testid="customer-product-title">{{ storeCustomer.attributes.product.title }}</p> -->
                            <div class="mb-4">
                                <v-row no-gutters>
                                    <v-col cols="12" class="mb-4">
                                        <div class="d-flex flex-column">
                                        <span :class="mobile ? 'text-body-1' : 'text-body-2'" class="grey--text">{{ $t('customerID')}}</span>
                                        <span class="text-body-1" data-testid="customer-customer-identifier">{{ storeCustomer.attributes.unique_id }}</span>
                                        </div>
                                    </v-col>
                                    <v-col cols="12" md="6" class="pr-2 pb-4 pb-md-0">
                                        <div class="d-flex flex-column">
                                        <span :class="mobile ? 'text-body-1' : 'text-body-2'" class="grey--text">{{ $t('customerName')}}</span>
                                        <span class="text-body-1" data-testid="customer-customer-name">{{ storeCustomer.attributes.first_name }} {{ storeCustomer.attributes.last_name }}</span>
                                        </div>
                                    </v-col>
                                    <v-col cols="12" md="6" >
                                        <div class="d-flex flex-column">
                                        <span :class="mobile ? 'text-body-1' : 'text-body-2'" class="grey--text">{{ $t('customerEmail')}}</span>
                                        <span class="text-body-1" data-testid="customer-customer-email">{{ storeCustomer.attributes.email }}</span>
                                        </div>
                                    </v-col>
                                </v-row>
                            </div>
                            <div class="mt-4">
                                <v-row no-gutters>
                                    <v-col cols="12" md="6" class="pr-2 pb-4 pb-md-0">
                                        <div class="d-flex flex-column">
                                        <span :class="mobile ? 'text-body-1' : 'text-body-2'" class="grey--text">{{ $t('customerCompanyName')}}</span>
                                        <span class="text-body-1" data-testid="customer-company-name">{{ storeCustomer.attributes.company_name }}</span>
                                        </div>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <div class="d-flex flex-column">
                                        <span :class="mobile ? 'text-body-1' : 'text-body-2'" class="grey--text">{{ $t('customerOrganizationNumber')}}</span>
                                        <span class="text-body-1" data-testid="customer-organization-number">{{ storeCustomer.attributes.organization_number }}</span>
                                        </div>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-card>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" lg="6">
                    <p>{{ $t('orders') }}</p>
                        <v-card rounded="xxl" class="elevation-2 pa-5" data-testid="customer-orders" v-if="storeOrders.length === 0">
                            <v-card-subtitle>{{ $t('orderNoResult') }}</v-card-subtitle>
                        </v-card>
                        <v-card rounded="xxl" class="elevation-2 pa-5" v-else>
                            <v-row  no-gutters v-if="!mobile()">
                                <v-col cols="12" md="4" class="pr-2">
                                    <span class="text-body-2 grey--text">{{ $t('orderCompany')}}</span>
                                </v-col>
                                <v-col cols="12" md="4" class="pr-2">
                                    <span class="text-body-2 grey--text">{{ $t('labelOrderNumber')}}</span>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <span class="text-body-2 grey--text">{{ $t('orderBy')}}</span>
                                </v-col>
                            </v-row>
                            <v-row v-for="(order, index) in storeOrders" :key="order.id" no-gutters class="mb-1 row-pointer" data-testid="order-customer" @click="redirectToOrder(order.id)">
                                <v-col cols="12" md="4" class="pr-2">
                                    <span v-if="mobile()" class="text-body-1 grey--text">{{ $t('orderCompany')}}: </span>
                                    <span class="text-body-1  mb-0 mt-1">{{ order.attributes.company_name }}</span>
                                </v-col>
                                <v-col cols="12" md="4" class="pr-2">
                                    <span v-if="mobile()" class="text-body-1 grey--text">{{ $t('labelOrderNumber')}}: </span>
                                    <span class="text-body-1  mb-0 mt-1">{{ order.attributes.number }}</span>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <span v-if="mobile()" class="text-body-1 grey--text">{{ $t('orderBy')}}: </span>
                                    <span class="text-body-1 mb-0 mt-1">{{ order.attributes.first_name }} {{ order.attributes.last_name }}</span>
                                    <v-divider v-if="mobile() && index < storeOrders.length - 1" class="my-2"/>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" lg="6">
                        <p>{{ $t('contacts') }}</p>
                        <v-card rounded="xxl" class="elevation-2 pa-5" data-testid="customer-contact" v-if="customerPersons.length === 0">
                            <v-card-subtitle>{{ $t('contactNoResult') }}</v-card-subtitle>
                        </v-card>
                        <v-card rounded="xxl" class="elevation-2 pa-5" v-else>
                            <v-row  no-gutters v-if="!mobile()">
                                <v-col cols="12" md="6" class="pr-2">
                                    <span class="text-body-2 grey--text">{{ $t('customerConatctName')}}</span>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <span class="text-body-2 grey--text">{{ $t('customerConatctMail')}}</span>
                                </v-col>
                            </v-row>
                            <v-row v-for="(participant, index) in customerPersons" :key="participant.id" no-gutters class="mb-1" data-testid="order-participant">
                                <v-col cols="12" md="6" class="pr-2">
                                    <span v-if="mobile()" class="text-body-1 grey--text">{{ $t('customerConatctName')}}: </span>
                                    <span class="text-body-1 mb-0 mt-1">{{ participant.attributes.first_name }} {{ participant.attributes.last_name }}</span>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <span v-if="mobile()" class="text-body-1 grey--text">{{ $t('customerConatctMail')}}: </span>
                                    <span class="text-body-1  mb-0 mt-1">{{ participant.attributes.email }}</span>
                                    <v-divider v-if="mobile() && index < customerPersons.length - 1" class="my-2"/>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <PlusButtonWithLink
            data-testid="create-contact-person-button"
            rounded="xl"
            :link="link"
        />
    </nav>
</template>

<script>
import { repeatedMethodsMixin } from '../../mixins/repeatedMethodsMixin'
import { getStoreCustomer, getStoreCustomerConatcts,getStoreOrdersCustomer } from '../../api/productApi'
import AlertMessages  from '../../components/AlertMessages'
import i18n from '../../plugins/i18n'
import PlusButtonWithLink from '../../components/PlusButtonWithLink'

export default {
    components: {
        AlertMessages,
        PlusButtonWithLink
    },
    mixins: [repeatedMethodsMixin],
    data(){
        return{
            alertType: '',
            alertMsg: '',
            alertValue:false,
            spaceId: window.$cookies.get('space_id'),
            loadingData: false,
            storeID: this.$route.params.id,
            space: window.location.host.split('.')[0],
            storeCustomer:{},
            customerPersons:[],
            storeOrders:[],
            link: {title: i18n.t('createCustomerContactTitle'), route: this.$route.params.id+'/customer-contact/create'},
        }
    },
    async created(){      
        this.loadingData = true
        await this.fetchStoreCustomer()
        await this.fetchStoreCustomerContacts()
        await this.fetchStoreOrdersCustomer()
        this.loadingData = false
    },
    methods:{
        async fetchStoreCustomer() {
            try {
                const response = await getStoreCustomer(this.storeID);
                if (response.status == 200) {
                    this.storeCustomer = response.data.data
                    
                }
            } catch (e) {
                if(e.response){
                    if(e.response.status == 404) {
                        this.$router.push({name: 'PageNotFound'})
                    }
                    else if(e.response.status == 403){
                        this.$router.push({name: 'PageAccessDenied'})
                    } else {
                        this.alertValue = true
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError')
                    }
                }
            }
        },
        async fetchStoreCustomerContacts() {
            try {
                const response = await getStoreCustomerConatcts(this.storeID);
                if (response.status == 200) {
                    this.customerPersons = response.data.data
                }
            } catch (e) {
                if(e.response){
                    if(e.response.status == 404) {
                        this.$router.push({name: 'PageNotFound'})
                    }
                    else if(e.response.status == 403){
                        this.$router.push({name: 'PageAccessDenied'})
                    } else {
                        this.alertValue = true
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError')
                    }
                }
            }
        },
        async fetchStoreOrdersCustomer() {
            try {
                const response = await getStoreOrdersCustomer(this.storeID);
                if (response.status == 200) {
                    this.storeOrders = response.data.data
                }
            } catch (e) {
                if(e.response){
                    if(e.response.status == 404) {
                        this.$router.push({name: 'PageNotFound'})
                    }
                    else if(e.response.status == 403){
                        this.$router.push({name: 'PageAccessDenied'})
                    } else {
                        this.alertValue = true
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError')
                    }
                }
            }
        },
        
        redirectToOrder(orderId) {
            this.$router.push({name: 'ViewOrder', params: {id: orderId}})
        }
    }
}
</script>  
